import React, { memo } from 'react';
import type { FC } from 'react';

import { expVal } from '@confluence/feature-experiments';
import { SmartFolderSyncIcon } from '@confluence/smart-folder/entry-points/SmartFolderSyncIcon.tsx';
import { useIsFolderSyncing } from '@confluence/smart-folder/entry-points/SmartFolderSyncContext.tsx';

/**
 * Small rotating sync icon shown next to the contextual after-icon buttons
 * in the page tree row when that folder is actively being synced.
 *
 * The icon and animation are shared with the FolderHeader via
 * `SmartFolderSyncIcon` from `@confluence/smart-folder`.
 *
 * Uses `useIsFolderSyncing` (backed by `useSyncExternalStore`) so that only
 * the row whose sync state changes re-renders — not every folder row.
 */
export const SmartFolderSyncSpinner: FC<{ folderId: string }> = memo(({ folderId }) => {
	const isSyncing = useIsFolderSyncing(folderId);
	if (!expVal('confluence_smart_folders_milestone_1', 'isEnabled', false) || !isSyncing) {
		return null;
	}
	return <SmartFolderSyncIcon testId="page-tree-folder-sync-spinner" />;
});
